import styled from 'styled-components';

export const CardContainer = styled.div`
  background: white;
  border-radius: 8px;
  border: 1px solid rgb(205, 199, 209);
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 32px;
  border-bottom: 1px solid rgb(205, 199, 209);
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
  margin: 0;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(128, 128, 128);
  margin: 4px 0 0 0;
`;

export const CheckboxRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  padding: 12px 32px;
  border-bottom: 1px solid rgb(235, 232, 237);
  align-items: center;
`;

export const ContentWrapper = styled.div`
  padding: 24px 32px;
  overflow-x: hidden;
  min-width: 0;
`;

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LegendContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 16px;
  justify-content: start;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendDot = styled.div<{ $color: string }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const LegendLabel = styled.span`
  font-size: 14px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(26, 23, 28);
`;

export const TooltipContent = styled.div`
  background: white;
  border: 1px solid rgb(205, 199, 209);
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 99999;
`;

export const TooltipTitle = styled.div`
  font-size: 14px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
  margin-bottom: 8px;
`;

export const TooltipRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 4px;
  font-size: 12px;
  font-family: Calibre-Regular, sans-serif;
`;

export const TooltipLabel = styled.span`
  color: rgb(128, 128, 128);
`;

export const TooltipValue = styled.span`
  color: rgb(26, 23, 28);
  font-family: Calibre-Semibold, sans-serif;
`;

export const NoDataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
`;

export const NoDataText = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(128, 128, 128);
`;
